<template>
  <Popper arrow class="report-popper">
    <div v-if="finished_tests.length">
      <div class="icon-wrapper">
        <i class="fas fa-box-archive"></i>
        <span class="tooltip">Скачать отчет</span>
      </div>
    </div>
    <template #content>
      <div class="list_header">
        <span>По датам</span>
      </div>
      <ul class="report_list">
        <template v-if="!test_type || (test_type !== 'management' && test_type !== 'full' && test_type !== 'standard')">
          <li v-for="report in finished_tests" :key="report.id" class="link download" @click="() => downloadReport(report.code)">
            <span role="button">
              {{ report.finished_at }}
            </span>
          </li>
        </template>
        <template v-else>
          <template v-for="report in finished_tests" :key="report.id">
            <template v-if="currentPassing === report.code">
              <li class="link new_reports">
                <div class="preloader_wrapper">
                  <mini-preloader />
                </div>
              </li>
            </template>
            <template v-else>

              <template v-if="test_type === 'management'">
                <li class="link new_reports">
                  <p class="download" role="button" @click="() => downloadReport(report.code, 'employee')">
                    Скачать отчет сотрудника, {{ report.finished_at }}
                  </p>
                </li>
                <li class="link new_reports">
                  <p class="download" role="button" @click="() => downloadReport(report.code, 'employer')">
                    Скачать отчет заказчика, {{ report.finished_at }}
                  </p>
                </li>
              </template>

              <template v-else-if="test_type === 'full' && report.finished_at">
                <li class="link new_reports">
                  <p class="download" role="button" @click="() => downloadReport(report.code)">
                    Скачать отчет для эксперта, {{ report.finished_at }}
                  </p>
                </li>
              </template>

              <template v-else-if="test_type === 'standard'  && report.finished_at">
                <li class="link new_reports">
                  <p class="download" role="button" @click="() => downloadReport(report.code)">
                    Скачать стандартный отчет, {{ report.finished_at }}
                  </p>
                </li>
              </template>
            </template>
          </template>
        </template>
      </ul>
    </template>
  </Popper>
</template>

<script>
import store from "@/store";
import {ref} from "@vue/runtime-core";
import MiniPreloader from "@/components/Technical/MiniPreloader.vue";

export default {
  name: "reports-render",
  components: {MiniPreloader},
  props: {
    finished_tests: Array,
    test_type: String,
  },
  setup(props) {
    const currentPassing = ref();
    const showMainTooltip = ref(true);
    const downloadReport = (passing, type = null) => {
      currentPassing.value = passing;
      store.dispatch("group/getReport", {
        passing: [ passing ],
        type: type,
      }).finally(() => {
        currentPassing.value = null;
      });
    }
    return {
      downloadReport,
      currentPassing,
      showMainTooltip
    }
  }
}
</script>

<style scoped lang="scss">

:deep(.popper),
:deep(.popper:hover),
:deep(.popper #arrow::before),
:deep(.popper #arrow::after),
:deep(.popper:hover > #arrow::before) {
  background-color: #fff;
}

.download {
  cursor: pointer;
  color: #00e287;
}

.download:hover {
  color: #00a65a;
}

.disable {
  color: #cccccc;
}

.fa-box-archive {
  cursor: pointer;
  font-size: 20px;
}

.fa-box-archive:hover {
  color: var(--hover-color)
}

.fas .disable {
  background-color: #cccccc;
}

.list_header {
  margin-bottom: 5px;
  color: #3D3D3D;
}

.report_list {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.new_reports {
  display: flex;
  flex-direction: column;
  color: #3D3D3D;
}

.preloader_wrapper {
  text-align: center;
}

.icon-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s;
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 12px;
  z-index: 1000;
}

.tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}

.icon-wrapper:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
</style>